module.exports = __webpack_public_path__ + "img/Solution-1.f129af63.png";